export const parseIntOrUndefined = value => {
  if (value) {
    const parsedValue = parseInt(value);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }
};
export const isInteger = value => Number.isInteger(value);